import React from 'react';
import { useTranslation } from 'react-i18next';
import FeatureCard from '../components/FeatureCard';
import freshdeskIllustration from '../assets/img/Illustration-Freshdesk.png';
import licensesIllustration from '../assets/img/Illustration-Licenses.png';

const ConnectorsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h1>{t('sidebar_connectors')}</h1>
      <div className="features-grid">
        <FeatureCard
          key="freshdesk"
          title={t('dashboard_freshdesk_title')}
          description={t('dashboard_freshdesk_description')}
          illustration={freshdeskIllustration}
          pluginName="freshdesk"
          to="/features/freshdesk"
          isComingSoon={false}
          isBuyWithoutFilling={false}
        />
        <FeatureCard
          key="mobile-app"
          title={t('dashboard_mobile_app_title')}
          description={t('dashboard_mobile_app_description')}
          illustration={licensesIllustration}
          pluginName="mobile"
          to="/features/mobile-app"
          isComingSoon={false}
          isBuyWithoutFilling={true}
        />
      </div>
    </div>
  );
};

export default ConnectorsPage;
